

if (!customElements.get('tab-collection-slider')) {

class TabCollectionSlider extends HTMLElement {
  constructor() {
    super();
    
    this.querySelectorAll('.tab-item').forEach((item, idx) => {
      item.addEventListener('click', (event) => {
        if (!event.target.classList.contains('active')) this.update(idx);
      });
      if (Shopify.designMode) {
        item.addEventListener('shopify:block:select', (event) => {
          if (!event.target.classList.contains('active')) this.update(idx);
        });
      }
    });
  }
  
  update(idx) {  
    this.querySelector('.tab-item.active').classList.remove('active');
    this.querySelectorAll('.tab-item')[idx].classList.add('active');


    this.querySelector('.tab-pane.active').classList.remove('active');
    this.querySelectorAll('.tab-pane')[idx].classList.add('visible');
    requestAnimationFrame(() => {
      this.querySelectorAll('.tab-pane')[idx].classList.add('active');
    });
  }
}
customElements.define('tab-collection-slider', TabCollectionSlider);
}


if (!customElements.get('content-tabs')) {
class ContentTabs extends HTMLElement {
  constructor() {
    super();

    this.querySelectorAll('.tab-item').forEach((item) => {

      item.addEventListener('click', () => {
        this.update(item.dataset.index);
      });

      if (Shopify.designMode) {
        item.addEventListener('shopify:block:select', () => {
          this.update(item.dataset.index);
        });
      }
    });
  }
  update(index) {

    // 移除所有 tab active
    this.querySelectorAll('.tab-item.active')
      .forEach(item => item.classList.remove('active'));

    // 激活对应 tab
    this.querySelectorAll(`.tab-item[data-index="${index}"]`)
      .forEach(item => item.classList.add('active'));

    // 内容切换
    const currentPane = this.querySelector('.tab-pane.active');

    if (currentPane) {
      currentPane.classList.remove('active');
    }

    const pane = this.querySelector(`.tab-pane[data-index="${index}"]`);

    if (pane) {
      pane.classList.add('visible');

      requestAnimationFrame(() => {
        pane.classList.add('active');
      });
    }
  }
}

customElements.define('content-tabs', ContentTabs);

}